import { render, staticRenderFns } from "./demandrecList.vue?vue&type=template&id=5a60b09a"
import script from "./demandrecList.vue?vue&type=script&lang=js"
export * from "./demandrecList.vue?vue&type=script&lang=js"
import style0 from "./demandrecList.vue?vue&type=style&index=0&id=5a60b09a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports